import { render, staticRenderFns } from "./TheForm.vue?vue&type=template&id=6d5dd191"
import script from "./TheForm.vue?vue&type=script&lang=js"
export * from "./TheForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports